import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlideOutComponent } from './slide-out.component';
import { MaterialsModule } from '../../modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '../buttons/buttons.module';

@NgModule({
  declarations: [SlideOutComponent],
  imports: [CommonModule, MaterialsModule, ButtonsModule, TranslateModule.forChild()],
  exports: [SlideOutComponent],
})
export class SlideOutModule {}
